export function removeSpaces(str: string) {
  return str.replace(/\s+/g, '');
}
